import { render } from "./AddWatchlistModal.vue?vue&type=template&id=4767d580&scoped=true"
import script from "./AddWatchlistModal.vue?vue&type=script&lang=js"
export * from "./AddWatchlistModal.vue?vue&type=script&lang=js"

import "./AddWatchlistModal.vue?vue&type=style&index=0&id=4767d580&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4767d580"]])

export default __exports__